module.exports = __webpack_public_path__ + "img/biaoqian_jichang.75853653.png";